import React from "react";
import { Field, ErrorMessage } from "formik";

import ErrorTextMessage from "../errorTextMessage/ErrorTextMessage";
import { EMPTY_STRING } from "../../../constants";

//-------InputTextField component start here
const InputTextField = (props) => {
  const {
    name,
    placeHolder,
    IconImage,
    LeftIconImage,
    type = "text",
    label,
    disabled = false,
    className,
    maxLength = 50,
    wrapperClassName,
    title = EMPTY_STRING,
    autoComplete = "off",
    isFocus = false,
    containerDivClassName = EMPTY_STRING,
    handleKeyDown = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
      }
    },
  } = props;
  //-------Return InputTextField Component
  return (
    <div
      className={`${
        !label && "input-field-min-width"
      } ${containerDivClassName}`}
    >
      {label && (
        <label className="field-label" htmlFor={name}>
          {label}
        </label>
      )}

      <div
        className={`input-field-wrapper ${
          wrapperClassName && wrapperClassName
        }`}
      >
        {IconImage && <IconImage className="icon-image" />}
        <Field
          className={`input-textfield ${
            IconImage || "input-textfield-without-icon"
          } ${LeftIconImage && "input-textfield-with-Lefticon"} ${
            className && className
          }`}
          type={type}
          maxLength={maxLength}
          id={name}
          name={name}
          title={title}
          placeholder={placeHolder}
          autoComplete={autoComplete}
          disabled={disabled}
          onKeyDown={handleKeyDown}
          autoFocus={isFocus}
        />
        {LeftIconImage && (
          <LeftIconImage
            className={`icon-image  ${
              LeftIconImage && "input-textfield-with-Lefticon"
            }`}
          />
        )}
      </div>
      <ErrorMessage name={name} component={ErrorTextMessage} />
    </div>
  ); //-------InputTextField component end here
};

//-------Export InputTextField Component
export default InputTextField;
